/**
 * Utility functions for handling recipe images
 */

const API_URL = process.env.REACT_APP_API_URL || '';

/**
 * Get the full URL for an image
 * If the image is already a full URL (http/https), return it as-is
 * If it's a local path (starts with /uploads), prepend the API base URL
 * @param {string} imageUrl - Image URL or path
 * @returns {string} Full image URL
 */
export function getImageUrl(imageUrl) {
  if (!imageUrl) {
    return null;
  }
  
  // If it's already a full URL (http/https), return as-is
  if (imageUrl.startsWith('http://') || imageUrl.startsWith('https://')) {
    return imageUrl;
  }
  
  // If it's a local path (starts with /uploads), prepend API base URL
  if (imageUrl.startsWith('/uploads/')) {
    return API_URL ? `${API_URL}${imageUrl}` : imageUrl;
  }
  
  // Otherwise, return as-is (might be a relative path or empty)
  return imageUrl;
}

